/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VoiceAgentProtocolEnum } from './VoiceAgentProtocolEnum';
import {
  VoiceAgentProtocolEnumFromJSON,
  VoiceAgentProtocolEnumFromJSONTyped,
  VoiceAgentProtocolEnumToJSON,
} from './VoiceAgentProtocolEnum';

/**
 *
 * @export
 * @interface VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreate
 */
export interface VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreate {
  /**
   *
   * @type {VoiceAgentProtocolEnum}
   * @memberof VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreate
   */
  protocol: VoiceAgentProtocolEnum;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreate
   */
  credentialValue?: string | null;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreate
   */
  name: string;
  /**
   *
   * @type {Date}
   * @memberof VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreate
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreate
   */
  serverUrl: string;
  /**
   * The API key of your LiveKit project (an identifier, not a secret). The API secret goes into the credential.
   * @type {string}
   * @memberof VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreate
   */
  apiKey: string;
  /**
   * The name your agent registers under with LiveKit. It must match exactly, otherwise the agent is never dispatched into the room.
   * @type {string}
   * @memberof VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreate
   */
  agentName: string;
  /**
   * Optional text sent verbatim to the agent as its job metadata (e.g. a JSON string). Leave empty if your agent does not expect any.
   * @type {string}
   * @memberof VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreate
   */
  dispatchMetadata?: string;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreate
   */
  voice?: string;
  /**
   *
   * @type {number}
   * @memberof VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreate
   */
  maxDuration?: number;
  /**
   * Maximum number of conversations run in parallel. Set it to the concurrent agent session limit of your LiveKit plan.
   * @type {number}
   * @memberof VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreate
   */
  maxConcurrency?: number;
  /**
   *
   * @type {number}
   * @memberof VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreate
   */
  credentialId?: number | null;
}

/**
 * Check if a given object implements the VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreate interface.
 */
export function instanceOfVoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreate(
  value: object,
): value is VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreate {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('serverUrl' in value) || value['serverUrl'] === undefined) return false;
  if (!('apiKey' in value) || value['apiKey'] === undefined) return false;
  if (!('agentName' in value) || value['agentName'] === undefined) return false;
  return true;
}

export function VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreateFromJSON(
  json: any,
): VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreate {
  return VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreateFromJSONTyped(json, false);
}

export function VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreate {
  if (json == null) {
    return json;
  }
  return {
    protocol: VoiceAgentProtocolEnumFromJSON(json['protocol']),
    credentialValue: json['credential_value'] == null ? undefined : json['credential_value'],
    name: json['name'],
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    serverUrl: json['server_url'],
    apiKey: json['api_key'],
    agentName: json['agent_name'],
    dispatchMetadata: json['dispatch_metadata'] == null ? undefined : json['dispatch_metadata'],
    voice: json['voice'] == null ? undefined : json['voice'],
    maxDuration: json['max_duration'] == null ? undefined : json['max_duration'],
    maxConcurrency: json['max_concurrency'] == null ? undefined : json['max_concurrency'],
    credentialId: json['credential_id'] == null ? undefined : json['credential_id'],
  };
}

export function VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreateToJSON(
  value?: VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreate | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: VoiceAgentProtocolEnumToJSON(value['protocol']),
    credential_value: value['credentialValue'],
    name: value['name'],
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    server_url: value['serverUrl'],
    api_key: value['apiKey'],
    agent_name: value['agentName'],
    dispatch_metadata: value['dispatchMetadata'],
    voice: value['voice'],
    max_duration: value['maxDuration'],
    max_concurrency: value['maxConcurrency'],
    credential_id: value['credentialId'],
  };
}
